type Tenant =
    | 'fitx'
    | 'gymlab'
    | 'pilot-fitx'
    | 'lfg'
    | 'bestfit'
    | 'rsg-group';

export type Feature =
    | 'MYSPORTS_MESSAGE'
    | 'COMM_MATRIX_DATA_PRIVACY'
    | 'COMM_MATRIX_MYSPORTS_RENAME'
    | 'EXTRAORDINARY_CANCELLATION_ALTERNATIVE_HELPER_TEXT'
    | 'FITX_ADDITIONAL_PRIVACY_INFORMATION'
    | 'COMMUNICATION_FEATURE_MODULES'
    | 'RENAME_MYSPORTS_MESSAGE'
    | 'UK_ADDRESS_FORMAT'
    | 'DOUBLE_OPT_IN';

interface TenantFeatureFlagsWildCard {
    '*': boolean;
}

type TenantFeatureFlags = {
    [key in Tenant]?: boolean;
} & TenantFeatureFlagsWildCard;

export type FeatureFlag = boolean | TenantFeatureFlags;

export type FeatureFlags = {
    [key in Feature]: FeatureFlag;
};

export const featuresProd: FeatureFlags = {
    MYSPORTS_MESSAGE: true,
    COMM_MATRIX_DATA_PRIVACY: {
        '*': false,
        fitx: true,
        'pilot-fitx': true,
        gymlab: true
    },
    COMM_MATRIX_MYSPORTS_RENAME: {
        '*': false,
        fitx: true,
        'pilot-fitx': true,
        gymlab: true
    },
    EXTRAORDINARY_CANCELLATION_ALTERNATIVE_HELPER_TEXT: {
        '*': false,
        fitx: true,
        'pilot-fitx': true,
        gymlab: true
    },
    FITX_ADDITIONAL_PRIVACY_INFORMATION: {
        '*': false,
        fitx: true,
        'pilot-fitx': true,
        gymlab: true
    },
    COMMUNICATION_FEATURE_MODULES: true,
    RENAME_MYSPORTS_MESSAGE: true,
    UK_ADDRESS_FORMAT: true,
    DOUBLE_OPT_IN: true
};

export const featuresStage: FeatureFlags = {
    MYSPORTS_MESSAGE: true,
    COMM_MATRIX_DATA_PRIVACY: true,
    COMM_MATRIX_MYSPORTS_RENAME: true,
    EXTRAORDINARY_CANCELLATION_ALTERNATIVE_HELPER_TEXT: true,
    FITX_ADDITIONAL_PRIVACY_INFORMATION: true,
    COMMUNICATION_FEATURE_MODULES: true,
    RENAME_MYSPORTS_MESSAGE: true,
    UK_ADDRESS_FORMAT: true,
    DOUBLE_OPT_IN: true
};
